import script from "./PayPalButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PayPalButton.vue?vue&type=script&setup=true&lang=js"

import "./PayPalButton.vue?vue&type=style&index=0&id=77fd531e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77fd531e"]])

export default __exports__